import { getErrorResult } from "./result";
import { HelperEvaluator } from "./helper";

export class RelationalEvaluator extends HelperEvaluator {
    constructor(formulaEvaluator, storeContext) {
        super(formulaEvaluator, storeContext);
    }

    async equalTo(exp) {
        const left = await this.evalNum(exp.Children[0]);
        const right = await this.evalNum(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const value = left.Value === right.Value;

        return { Value: value };
    }

    async notEqualTo(exp) {
        const result = await this.equalTo(exp);
        return this._negateResult(result);
    }

    async greaterThan(exp) {
        const left = await this.evalNum(exp.Children[0]);
        const right = await this.evalNum(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const value = left.Value > right.Value;

        return { Value: value };
    }

    async lessThan(exp) {
        const left = await this.evalNum(exp.Children[0]);
        const right = await this.evalNum(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const value = left.Value < right.Value;

        return { Value: value };
    }

    async greaterThanOrEqualTo(exp) {
        const left = await this.evalNum(exp.Children[0]);
        const right = await this.evalNum(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const value = left.Value >= right.Value;

        return { Value: value };
    }

    async lessThanOrEqualTo(exp) {
        const left = await this.evalNum(exp.Children[0]);
        const right = await this.evalNum(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const value = left.Value <= right.Value;

        return { Value: value };
    }
}
